import { render } from "./PatientPayerInformation.vue?vue&type=template&id=a7a62f68"
import script from "./PatientPayerInformation.ts?vue&type=script&lang=js&external"
export * from "./PatientPayerInformation.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__